export default {
  cashFlowDetails: null,
  cashFlowDetailsError: null,
  cashFlowForecast: null
}
